import { useParams } from "@tanstack/react-router"
import { Page } from "../../../../-components/Page"
import { router } from "../../../../router"
import { ColumnLayout } from "../../-components/column-layout"
import { DetailsCard } from "../../-components/details-card"
import { LabeledValue } from "../../../../-components/default-list/labeled-value"
import { Text, SimpleGrid } from "@mantine/core"
import { FieldData } from "../../../../-components/field-data"
import useGetResourceObjectFieldTypes from "./useGetResourceObjectFieldTypes"
import { useTranslation } from "react-i18next"
import { AttachmentCarousel } from "../../-components/AttachmentCarousel"
import { useGetResourceSuspense } from "@/orval/gen"
import { useGetResourceObjectsByResourceIdSuspense } from "@/orval/gen"

export function ResourceDetailsPage() {
  const resourceId = parseInt(useParams({ from: "/app/resources/$id" }).id)
  const { data: resource } = useGetResourceSuspense({ resourceId })
  const { data: objects } = useGetResourceObjectsByResourceIdSuspense({
    resourceId,
  })
  const { data: objectFieldTypes } = useGetResourceObjectFieldTypes(
    resource.category
  )
  const { t } = useTranslation("app_server")

  React.useEffect(() => {
    router.invalidate()
  }, [resource])

  const detailsData = React.useMemo(
    () => [
      { label: t("Name"), value: resource.name },
      { label: t("Type"), value: resource.resourceType },
      { label: t("RentalFee"), value: resource.rentalFee },
      { label: t("CleaningCost"), value: resource.cleaningCost },
      { label: t("Location"), value: resource.location },
    ],
    [t, resource]
  )

  return (
    <Page>
      <ColumnLayout>
        {resource.attachments.length > 0 && (
          <AttachmentCarousel
            attachments={resource.attachments}
            containerId={resource.resourceId}
            controllerRoute="resources"
          />
        )}
        <DetailsCard title={t("Details")}>
          {detailsData
            .filter((d) => !!d.value)
            .map((data, i) => (
              <LabeledValue key={i} {...data} />
            ))}
        </DetailsCard>
        {resource.resourceFields.map((rf, i) => (
          <DetailsCard key={i} title={rf.key ?? t("Details")}>
            {rf.value?.map((rf) => (
              <LabeledValue
                key={rf.name}
                label={rf.name}
                value={<FieldData fieldData={rf} />}
              />
            ))}
          </DetailsCard>
        ))}
        <DetailsCard title={t(`ResourceObjectCategory_${resource.category}`)}>
          <SimpleGrid cols={2 + objectFieldTypes.length}>
            <Text>{t("Code")}</Text>
            <Text>{t("Condition")}</Text>
            {objectFieldTypes.map((t) => (
              <Text key={t.id}>{t.name}</Text>
            ))}
            {objects.map((o) => (
              <React.Fragment key={o.resourceObjectId}>
                <Text>{o.identificationCode}</Text>
                <Text>{o.condition}</Text>
                {objectFieldTypes.map((t) => {
                  const fieldData = o.objectFields.find(
                    (f) => f.name === t.name
                  )
                  if (!fieldData) return null
                  return <FieldData key={t.id} fieldData={fieldData} />
                })}
              </React.Fragment>
            ))}
          </SimpleGrid>
        </DetailsCard>
      </ColumnLayout>
    </Page>
  )
}
